(ns app.front.view.bond.list
  (:require [app.domain.bond.model :as bond-model]
            [app.front.entities :as entities]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil]
            [app.front.view.bond.common :as bond-common]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-my-bonds
  (fn [_ _]
    {:dispatch [:comm/command-monitored
                {:command    :bond/get-my-bonds
                 :method     :get
                 :on-success [::entities/override-entity-db]}]}))

(rf/reg-sub ::bonds
  :<- [::entities/context]
  (fn [ctx [_ owner-id]]
    (->> (entities/find-entities ctx {:bond/owner owner-id})
         (sort-by :entity/created)
         seq)))

(defn bond-list [{:keys [title tr owner-entity-id]}]
  (when-let [bonds (<sub [::bonds owner-entity-id])]
    (let [lang (<sub [:language])]
      [section/section
       :bonds
       {:tr tr}
       title
       [ui-table/modern-responsive-table
        (util/mmap {:cols       [[(tr [:bond/account-number]) #(or (:bond/external-id %) "-")]
                                 [(tr [:bond/group-name]) #(-> % :entity/parent :group/name)]
                                 [(tr [:bond/type]) #(bond-model/bond-type-name % lang)]
                                 [(tr [:bond/amount])
                                  #(futil/money-string (:bond/amount %)
                                                       (-> % :entity/parent :group/currency))]
                                 [(tr [:bond/expires-on])
                                  (fn [bond]
                                    (if-let [expires-on (:bond/expires-on bond)]
                                      (date-util/date (<sub [:language]) expires-on)
                                      "-"))]
                                 [(tr [:bond/status])
                                  #(tr [(:domain/state %)])]]
                    :items      bonds
                    :get-status bond-common/bond-status-colors
                    :link       {:description (tr [:bond/view])
                                 :make-href   #(href/href :view/bond.base
                                                          {:bond-id (:bond/id %)})}}
                   tr)]])))
